<template>
  <div class="apply">
    <back />

    <h3>基本信息</h3>
    <div class="card-wrapper info">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" label-position="top">
        <el-form-item label="问卷标题" prop="questionTitle">
          <div class="item-row">
            <el-input v-model="ruleForm.questionTitle" placeholder="请输入问卷标题"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="问卷描述" prop="desc">
          <div class="item-row">
            <el-input v-model="ruleForm.desc" type="textarea" placeholder="请输入问卷描述" :autosize="{ minRows: 4, maxRows: 6 }"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="活动时间" prop="date1">
          <div class="item-row">
            <el-date-picker v-model="ruleForm.date1" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <h3>题目设置</h3>
    <div class="card-wrapper question-list">
      <div class="card-wrapper list-item" v-for="(item, index) in ruleForm.questionList" :key="index">
        <div class="list-item-title-wrapper">
          <div class="list-item-title">
            <div class="question-btn">
              <el-tag v-if="item.questionType == 1" class="tag1" color="#DBEAFE" size="">{{ questionFeature(item.questionType) }}</el-tag>
              <el-tag v-if="item.questionType == 2" class="tag2" color="#DCFCE7" size="">{{ questionFeature(item.questionType) }}</el-tag>
              <el-tag v-if="item.questionType == 3" class="tag3" color="#F3E8FF" size="">{{ questionFeature(item.questionType) }}</el-tag>
            </div>
            <div class="question-num">第 {{ index + 1 }} 题</div>
            <div class="required">
              <el-checkbox v-model="item.requiredFlag">必填</el-checkbox>
            </div>
          </div>
          <div class="">
            <el-button type="" icon="el-icon-top" :disabled="index == 0" circle @click="onUp(index)"></el-button>
            <el-button type="" icon="el-icon-bottom" :disabled="index == ruleForm.questionList.length - 1" circle @click="onDown(index)"></el-button>
            <el-button type="danger" icon="el-icon-delete" circle @click="onDel(index)"></el-button>
          </div>
        </div>
        <div class="question-title">
          <el-input v-model="item.questionName" placeholder="请输入题目"></el-input>
        </div>
        <!-- 单选题 -->
        <div class="radio-com" v-if="item.questionType == 1">
          <div class="com-item" v-for="(op, opindex) in item.optionDtoList" :key="opindex">
            <el-radio disabled :label="opindex + 1">
              <el-input v-model="op.optionName" placeholder="请输入选项内容"></el-input>
            </el-radio>
            <div class="del">
              <el-button type="danger" icon="el-icon-delete" :disabled="item.optionDtoList.length <= 1" circle @click="onDelOne(index, opindex)"></el-button>
            </div>
          </div>
          <div class="add-option">
            <el-button type="text" icon="el-icon-plus" @click="addOption(index)">增加选项</el-button>
          </div>
        </div>
        <!-- 多选题 -->
        <div class="check-com" v-if="item.questionType == 2">
          <div class="com-item" v-for="(op, opindex) in item.optionDtoList" :key="opindex">
            <el-checkbox disabled :label="opindex + 1">
              <el-input v-model="op.optionName" placeholder="请输入选项内容"></el-input>
            </el-checkbox>
            <div class="del">
              <el-button type="danger" icon="el-icon-delete" :disabled="item.optionDtoList.length <= 1" circle @click="onDelOne(index, opindex)"></el-button>
            </div>
          </div>
          <div class="add-option">
            <el-button type="text" icon="el-icon-plus" @click="addOption(index)">增加选项</el-button>
          </div>
        </div>
        <!-- <component ref="comRef" :is="comFeature(item.questionType)" :index="index" @radio-change="radioChange" /> -->
      </div>
    </div>

    <div class="card-wrapper add-question">
      <div class="tips">
        <i class="el-icon-circle-plus"></i>
        <span>请根据需要添加单选题、多选题或文本题</span>
      </div>
      <div class="add-btn">
        <el-button class="add1" icon="el-icon-circle-check" @click="addQuestion(1)">添加单选题</el-button>
        <el-button class="add2" icon="el-icon-finished" @click="addQuestion(2)">添加多选题</el-button>
        <el-button class="add3" icon="el-icon-edit" @click="addQuestion(3)">添加文本题</el-button>
      </div>
    </div>

    <div class="submit">
      <el-button type="primary" icon="el-icon-s-promotion" :loading="loading" @click="submitForm('ruleForm')">发布</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      ruleForm: {
        questionTitle: "",
        date1: [],
        desc: "",
        questionList: [
          {
            questionType: 1,
            questionName: "",
            requiredFlag: false,
            optionDtoList: [{ optionName: "" }],
          },
        ],
      },
      rules: {
        questionTitle: [{ required: true, message: "请输入问卷名称", trigger: "blur" }],
        date1: [{ required: true, message: "请选择时间", trigger: "change" }],
      },
    }
  },
  computed: {
    questionFeature() {
      return function (type) {
        switch (type) {
          case 1:
            return "单选题"
          case 2:
            return "多选题"
          case 3:
            return "文本题"
        }
      }
    },
  },
  methods: {
    // 增加题目 'radio':单选题、 'check':多选题、 'text':文本题
    addQuestion(type) {
      let obj = {
        questionType: type,
        questionName: "",
        optionDtoList: [{ optionName: "" }],
      }
      this.ruleForm.questionList.push(obj)
    },
    // 题目前移
    onUp(index) {
      if (index === 0) return
      let temp = this.ruleForm.questionList[index]
      this.ruleForm.questionList[index] = this.ruleForm.questionList[index - 1]
      this.ruleForm.questionList[index - 1] = temp
      // 更新视图
      this.$set(this.ruleForm.questionList, index - 1, temp)
    },
    // 题目后移
    onDown(index) {
      if (index === this.ruleForm.questionList.length - 1) return
      let temp = this.ruleForm.questionList[index]
      this.ruleForm.questionList[index] = this.ruleForm.questionList[index + 1]
      this.ruleForm.questionList[index + 1] = temp
      // 更新视图
      this.$set(this.ruleForm.questionList, index + 1, temp)
    },
    // 删除题目index
    onDel(index) {
      this.ruleForm.questionList.splice(index, 1)
    },
    // 删除题目选项index1,index2
    onDelOne(index, opindex) {
      this.ruleForm.questionList[index].optionDtoList.splice(opindex, 1)
    },
    // 增加选项
    addOption(index) {
      this.ruleForm.questionList[index].optionDtoList.push({
        optionName: "",
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        const list = this.ruleForm.questionList
        // 题目设置校验：
        // 单选题、多选题、文本题校验必须输入题目内容
        // 单选题、多选题至少一个选项并且每个已创建的选项内容不能为空
        for (let index = 0; index < list.length; index++) {
          const element = list[index]
          if (element.questionName === "") {
            this.$message.error(`请填写第 ${index + 1} 题的题目内容`)
            return false
          }
          if (element.questionType != 3) {
            for (let index1 = 0; index1 < element.optionDtoList.length; index1++) {
              const element1 = element.optionDtoList[index1]
              if (element1.optionName === "") {
                this.$message.error(`请填写第 ${index + 1} 题的第 ${index1 + 1} 个选项内容`)
                return false
              }
            }
          }
        }

        if (valid) {
          this.loading = true
          let questionDtoList = this.ruleForm.questionList.map(item => {
            return {
              ...item,
              requiredFlag: item.requiredFlag ? 1 : 0,
            }
          })
          let params = {
            questionnaireName: this.ruleForm.questionTitle,
            startTime: this.ruleForm.date1[0],
            endTime: this.ruleForm.date1[1],
            questionnaireIntroduce: this.ruleForm.desc,
            questionDtoList,
          }
          this.$axios
            .post(this.$api.insertQuestionnaireInfo, params)
            .then(res => {
              this.$message.success("发布成功")
              setTimeout(() => {
                this.$router.go(-1)
              }, 1000)
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$message.error("请填写完整问卷信息")
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.apply {
  h3 {
    margin: 20px 0;
  }

  .card-wrapper {
    border-radius: 12px;
    border: 1px solid #d1d5db;
    background-color: #f9fafb;
    padding: 30px;
    box-sizing: border-box;
  }

  .info {
    .el-date-editor {
      width: 100%;
    }

    .item-row {
      width: 60%;
    }
  }

  .question-list {
    .list-item {
      margin-bottom: 20px;

      .list-item-title-wrapper {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;

        .list-item-title {
          display: flex;
          align-items: center;

          .question-btn,
          .question-num,
          .required {
            margin-right: 30px;
          }

          .question-btn {
            .el-tag {
              border-radius: 10px;
            }

            .tag1 {
              color: #1d4ed8;
              border-color: rgba(29, 78, 216, 0.2);
            }

            .tag2 {
              color: #15803d;
              border-color: rgba(21, 128, 61, 0.2);
            }

            .tag3 {
              color: #7e22ce;
              border-color: rgba(126, 34, 206, 0.2);
            }
          }
        }

        ::v-deep .el-icon-top,
        ::v-deep .el-icon-bottom {
          font-weight: bold;
        }
      }

      .radio-com,
      .check-com {
        margin-top: 10px;

        .el-radio,
        .el-checkbox,
        .com-item {
          display: flex;
          align-items: center;
          width: 100%;
          margin: 0 0;
        }

        ::v-deep .el-radio__label,
        ::v-deep .el-checkbox__label {
          display: block;
          width: 100%;
        }

        .com-item {
          margin-bottom: 10px;

          .del {
            margin-left: 10px;
          }
        }
      }
    }
  }

  .add-question {
    margin-top: 30px;
    text-align: center;

    .tips {
      color: #6b7280;
      margin-bottom: 20px;

      .el-icon-circle-plus {
        margin-right: 5px;
      }
    }

    .add-btn {
      .add1 {
        background-color: #1d4ed8;
        border-color: #1d4ed8;
        color: white;

        &:hover {
          background-color: rgba(29, 78, 216, 0.8);
          border-color: rgba(29, 78, 216, 0.8);
        }
      }

      .add2 {
        background-color: #15803d;
        border-color: #15803d;
        color: white;

        &:hover {
          background-color: rgba(21, 128, 61, 0.8);
          border-color: rgba(21, 128, 61, 0.8);
        }
      }

      .add3 {
        background-color: #9c27b0;
        border-color: #9c27b0;
        color: white;

        &:hover {
          background-color: rgba(156, 39, 176, 0.8);
          border-color: rgba(156, 39, 176, 0.8);
        }
      }
    }
  }

  .submit {
    margin: 50px 0;
    text-align: center;

    .el-button {
      width: 150px;
    }
  }
}
</style>
